


import React, { useState } from "react";
import { Eye, EyeOff, Lock } from "lucide-react";
import {
  useParams,
  useNavigate
} from "react-router-dom";
import "./Firstpage.css";

const ForgotPassword = () => {

  const navigate = useNavigate();
  const { token } = useParams();

  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  // Handle change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // Validation
  const validateForm = () => {
    const newErrors = {};

    if (!formData.newPassword) {
      newErrors.newPassword = "Password required";
    } else if (formData.newPassword.length < 6) {
      newErrors.newPassword = "Minimum 6 characters";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Confirm your password";
    } else if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    if (!token) {
      setErrors({ submit: "Invalid or expired reset link" });
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(
        `https://backend.maamaas.com/subscription/api/auth/partner/reset-password?token=${token}&newPassword=${encodeURIComponent(formData.newPassword)}`,
        {
          method: "PUT",
          headers: {
            Accept: "*/*",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to reset password");
      }

      const data = await response.text(); // ya response.json() agar API JSON return karti hai

      setSuccessMsg("Password reset successful!");

      setTimeout(() => {
        navigate("/movers-login");
      }, 2000);
    } catch (error) {
      console.error(error);
      setErrors({
        submit: "Failed to reset password. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="forgot-container">
      <div className="card">
        <h2>Reset Password</h2>

        {successMsg && <div className="success">{successMsg}</div>}

        <form onSubmit={handleSubmit}>
          {/* New Password */}
          <div className="form-group">
            <label>New Password</label>
            <div className="input-box">
              <input
                type={showNewPassword ? "text" : "password"}
                name="newPassword"
                placeholder="Enter new password"
                value={formData.newPassword}
                onChange={handleChange}
              />
              <span onClick={() => setShowNewPassword(!showNewPassword)}>
                {showNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>
            {errors.newPassword && <p className="error">{errors.newPassword}</p>}
          </div>

          {/* Confirm Password */}
          <div className="form-group">
            <label>Confirm Password</label>
            <div className="input-box">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                placeholder="Confirm password"
                value={formData.confirmPassword}
                onChange={handleChange}
              />
              <span onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>
            {errors.confirmPassword && (
              <p className="error">{errors.confirmPassword}</p>
            )}
          </div>

          {errors.submit && <p className="error">{errors.submit}</p>}

          <button disabled={isSubmitting}>
            {isSubmitting ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;